import React from "react";

// import portfolio1 from "../../../src/assets/images/portfolio1.jpg";
// import portfolio2 from "../../../src/assets/images/portfolio2.jpg";
// import portfolio3 from "../../../src/assets/images/portfolio3.jpg";
// import portfolio4 from "../../../src/assets/images/portfolio4.jpg";
// import portfolio5 from "../../../src/assets/images/portfolio5.jpg";

import ProjectApi from "../../../Data/HomePage/PortfolioApi";
import ReusableModal from "../../../components/PortfolioModal";
// import { useHistory } from 'react-router-dom'; 
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";

function PortfolioArea() {
  const categories = ProjectApi.categories || [];
  const navigate = useNavigate();

  const handleImageClick = (projectId) => {
    // navigate.push(`/project/${projectId}`); 
    navigate(`/project/${projectId}`); 
  }

  const { id } = useParams();

  console.log(categories);
  return (
    <>
      <section
        className="portfolio-area page-section scroll-to-page"
        id="portfolio"
      >
        <div className="custom-container">
          <div className="portfolio-content content-width">
            <div className="section-header">
              <h4
                className="subtitle scroll-animation"
                data-animation="fade_from_bottom"
              >
                <i className="las la-grip-vertical"></i> portfolio
              </h4>
              <h1
                className="scroll-animation"
                data-animation="fade_from_bottom"
              >
                Featured <span>Projects</span>
              </h1>
            </div>

            <ul className="nav nav-tabs" id="myTab" role="tablist">
              {categories.map((category) => (
                <li key={category.id} className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${category.id === "ios-development" ? "active" : ""}`}
                    id={`${category.id}-tab`}
                    data-bs-toggle="tab"
                    data-bs-target={`#${category.id}-tab-pane`}
                    type="button"
                    role="tab"
                    aria-controls={`${category.id}-tab-pane`}
                    aria-selected={category.id === "ios-development" ? "true" : "false"}
                  >
                    {category.name}
                  </button>
                </li>
              ))}
            </ul>

            <div className="tab-content mt-5" id="myTabContent">
              {categories.map((category) => (
                <div
                  key={category.id}
                  className={`tab-pane fade ${category.id === "ios-development" ? "show active" : ""}`}
                  id={`${category.id}-tab-pane`}
                  role="tabpanel"
                  aria-labelledby={`${category.id}-tab`}
                  tabIndex="0"
                >
                  <div className="row portfolio-items">
                    {category.projects && category.projects.map((project) => (
                      <div
                        key={project.id}
                        className="col-md-6 scroll-animation"
                        data-animation="fade_from_right"
                      >
                        <div className="portfolio-item portfolio-half">
                          <div className="portfolio-item-inner">
                            
                              <img src={(`${project.banner}`)}
                              alt={project.title} onClick={() => handleImageClick(project.id)} style={{ cursor: 'pointer' }}/>
                     
                            {<ul className="portfolio-categories">
                              {project.techStack && project.techStack.map((cat, index) => (
                                <li key={index}>
                                  <a href="javascript:void(0)">{cat}</a>
                                </li>
                              ))}
                            </ul> }
                          </div>
                          <h2>
                            <a href="">{project.title}</a>
                          </h2>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      
      </section>
    </>
  );
}

export default PortfolioArea;
